import PetService from '@/api/services/PetService';

export const namespaced = true;

export const state = {
  pets: [],
  fetchPets: {
    error: null,
    isSuccess: false,
    isLoading: false,
  },
  error: null,
  isSuccess: false,
  isLoading: false,
};

export const getters = {
  getAllActivePetNames: (state) => state.pets?.filter((pet) => pet.status === 'A').map((pet) => pet.name || '') || [],
  getAllInactivePetNames: (state) => state.pets?.filter((pet) => pet.status !== 'A').map((pet) => pet.name || '') || [],
  getError: ({ error }) => error,
};

export const mutations = {
  //  FETCH PET
  SET_FETCH_PETS_SUCCESS(state, allPets) {
    state.fetchPets.error = null;
    state.pets = allPets || [];
  },
  SET_FETCH_PETS_FAILURE(state, error) {
    state.fetchPets.error = error;
  },
  SET_FETCH_PETS_LOADING_ON(state) {
    state.fetchPets.isLoading = true;
  },
  SET_FETCH_PETS_LOADING_OFF(state) {
    state.fetchPets.isLoading = false;
  },
  //   ADD PET
  SET_ADD_PET_SUCCESS(state) {
    state.error = null;
  },
  SET_ADD_PET_FAILURE(state, error) {
    state.error = error;
  },
  SET_ADD_PET_LOADING_ON(state) {
    state.isLoading = true;
  },
  SET_ADD_PET_LOADING_OFF(state) {
    state.isLoading = false;
  },
  clearError(state) {
    state.error = null;
  },
};

export const actions = {
  fetchPets: ({ commit }) => {
    commit('SET_FETCH_PETS_LOADING_ON');
    PetService.fetchPets()
      .then(({ allPets }) => commit('SET_FETCH_PETS_SUCCESS', allPets))
      .catch(({ error }) => commit('SET_FETCH_PETS_FAILURE', error))
      .finally(() => commit('SET_FETCH_PETS_LOADING_OFF'));
  },
  async addPet({ commit, dispatch }, { payload }) {
    try {
      commit('SET_ADD_PET_LOADING_ON');

      const pet = await PetService.addPet(payload);

      commit('SET_ADD_PET_SUCCESS');

      await dispatch('notification/notifySuccess', { message: `${payload.name} has been added to your account.` }, { root: true });

      return pet;
    } catch (error) {
      commit('SET_ADD_PET_FAILURE', error?.message);

      await dispatch(
        'notification/notifyFailure',
        {
          message: 'Failed to add a new pet.',
          options: { dismissSecs: 15 },
        },
        { root: true }
      );

      throw error;
    } finally {
      commit('SET_ADD_PET_LOADING_OFF');
    }
  },
  clearErrors(store) {
    store.commit('clearError');
  },
};
